import {
  EnvironmentProviders,
  Provider,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  BdAppConfigRequest,
  BdAppConfigResponse,
} from '@bindoc-projects/app-config-domain-lib';
import { provideMsalWithHttp } from '@bindoc-projects/security-lib/data';
import { provideUserCookieDomainId } from '@bindoc-projects/user-lib/data';
import { provideDiagnosticsConfig } from '@bindoc-projects/diagnostics-lib/data';
import { provideAppConfig } from './bootstrap';
import { AppCoreOptions, provideAppCore } from './core';
import { provideI18nDe } from './i18n/de';
import { providePermissionPrefetch } from './permission-prefetch';

export interface AuthenticatedAppOptions extends Omit<AppCoreOptions, 'auth'> {
  config: BdAppConfigResponse;
  configRequest: BdAppConfigRequest;
  permissionPrefetch?: boolean;
  /** Preserve the DE import app's implicit Angular default. */
  explicitZoneless?: boolean;
}

/** Shared browser/session scaffolding. Apps retain routes, theme, country overrides and hydration. */
export function provideAuthenticatedApp(
  options: AuthenticatedAppOptions,
): Array<Provider | EnvironmentProviders> {
  const {
    config,
    configRequest,
    permissionPrefetch,
    explicitZoneless,
    ...core
  } = options;
  return [
    ...provideI18nDe(),
    ...provideMsalWithHttp(config),
    ...(permissionPrefetch ? [providePermissionPrefetch()] : []),
    ...provideAppCore({ ...core, auth: 'msal' }),
    provideAppConfig(config),
    ...(explicitZoneless === false ? [] : [provideZonelessChangeDetection()]),
    provideUserCookieDomainId(config),
    provideDiagnosticsConfig(configRequest, config),
  ];
}
